// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, anyOf, maybe } from "@altostra/type-validations";
import { string, number, boolean, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

const executionUsageData = objectOf({
  limits: objectOf({
    daily: maybe(number),
    max_daily: maybe(number),
    total: maybe(number),
  }),
  current_usage: objectOf({
    today: maybe(number),
    total: maybe(number),
  }),
  remaining: objectOf({
    today: maybe(number),
    total: maybe(number),
  }),
  exceeded_limit: boolean,
});

const recentExecutionsData = objectOf({
  daily_success_counts: arrayOf(number),
  daily_error_counts: arrayOf(number),
  total_success: number,
  total_error: number,
  total: number,
});

export const generativeAiAgentsResultItem = objectOf({
  id: string,
  name: string,
  description: string,
  model: string,
  provider: number,
  updated_at: number,
  created_at: number,
  last_executed_at_with_hour_granularity: anyOf(number, nullOrUndefined),
  created_by: string,
  marked_as_deleted: boolean,
  interaction_site: number,
  territory_ids: arrayOf(string),
  recent_executions: anyOf(recentExecutionsData, nullOrUndefined),
});

export const isGenerativeAiAgentsResult = objectOf({
  hits: number,
  results: arrayOf(generativeAiAgentsResultItem),
  global_execution_usage: anyOf(executionUsageData, nullOrUndefined),
});
